<script setup lang="ts">
import { OnClickOutside } from "@vueuse/components";
import { useModal } from "shared/composables";

import { ELEMENT_SIZE } from "~/common/interfaces/element-size.enum";
import { useAuthStore } from "~/stores/auth";
import { useUsersStore } from "~/stores/users";

const usersStore = useUsersStore();
const authStore = useAuthStore();
const { toggleModal, closeModal, isModalOpened } = useModal();

const handleSignOut = () => {
	authStore.signOut();
	navigateTo("/login");
};
</script>

<template>
	<OnClickOutside @trigger="closeModal">
		<div
			class="relative"
		>
			<button class="flex" @click="toggleModal">
				<CommonAvatar
					:email="usersStore.me.email"
					:size="ELEMENT_SIZE.SM"
				/>
			</button>
			<AppDropdown
				v-if="isModalOpened"
				class="right-0 top-6"
				@click="closeModal"
			>
				<NuxtLink to="/settings">
					<AppButton tag="li">
						{{ $t('COMMON.settings') }}
					</AppButton>
				</NuxtLink>
				<AppButton
					tag="li"
					@click="handleSignOut"
				>
					{{ $t('COMMON.signOut') }}
				</AppButton>
			</AppDropdown>
		</div>
	</OnClickOutside>
</template>
